import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-multirisque-habitation',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-multirisque-habitation.component.html',
  styleUrls: ['./assurance-multirisque-habitation.component.scss']
})
export class AssuranceMultirisqueHabitationComponent {
  title = 'Assurance Multirisque Habitation';
  subtitle = '';
  phoneNumber = '01 43 27 12 43';
  heroImage = 'assets/static_pages_images/habitation.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Habitation', link: undefined }
  ];

  prevPage = { title: 'Assurance Voyage Personnel',
    link: '/assurance-voyage-personnel'
  };

  nextPage = { title: 'Assurance Moto Personnelle',
    link: '/assurance-moto-personnelle'
  };

  // Partners logos for carousel
  partners = [
    { name: 'Generali', logo: 'assets/logos/generali.png' },
    { name: 'April', logo: 'assets/logos/april.png' },
    { name: 'FMA', logo: 'assets/logos/fma.png' },
    { name: 'Swiss Life', logo: 'assets/logos/SWISSLIFE.PNG' },
    { name: 'Liberty', logo: 'assets/logos/liberty.png' },
    { name: 'Novelia', logo: 'assets/logos/novelia.png' },
    { name: 'Zephir', logo: 'assets/logos/zephir.png' },
    { name: 'Netvox', logo: 'assets/logos/netvox.png' },
  ];

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}

